<template>
  <div class="reference">
    <div class="title">{{title}}</div>
    <div class="reference">{{reference}}</div>
  </div>
</template>

<script>
export default {
  name: 'Reference',
  props: ["title", "reference"],
  data () { return {} },
  components: {}
}
</script>
<style lang="scss" scoped>

.reference {
  .title {
    // font-weight: 500;
    font-style: italic;
  }
  .reference {

  }
}

</style>
